// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-component-loader-js": () => import("./../../../src/pages/component/loader.js" /* webpackChunkName: "component---src-pages-component-loader-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

